/* @ngInject */
function AssetPreviewImageController ($scope, $interval, $rootScope, $timeout, $location, NewAssetService, AssetPreviewService, SegmentService, ArtsService, SocketService, Utils, CONSTANTS, ShareLinkService) {
  $scope.imagePreviewURL = ''
  $scope.watermarkUrl = '/assets/img/backgrounds/watermark-deskfy.png'
  $scope.imageLayers = []
  $scope.imageScale = 1
  $scope.imageScaleRatio = 0.25
  $scope.maxImageScale = 4
  $scope.currentLayerIndex = 0
  $scope.layersMaxHeight = 0
  $scope.showCommentsPins = false
  const sectionAllowsDownload = $scope.template?.allowUserDownload || $scope.contextData.section?.allowUserDownload

  $scope.panConfig = {
    elViewport: null,
    elCanvas: null,
    elWatermark: null,
    offset: { x: 0, y: 0 },
    isPan: null,
    isVertical: false,
    isHorizontal: false,
    imgSizeDiffX: 0,
    imgSizeDiffY: 0
  }

  $scope.isRenderingPreview = false

  $scope.flags = {
    zoomOut: false,
    hasMultipleLayers: false,
    loading: true,
    isFullscreen: false,
    showWatermark: false
  }

  const api = {
    _getArtPreviewSrc,
    _updateImageScale,
    _resetImageScale,
    _checkVerticalOverflow,
    _checkHorizontalOverflow,
    _getImagePanningConfigs,
    _handleImagePanning,
    _handlePanningScale,
    _handleInitialScale,
    _panStart,
    _panMove,
    _panEnd,
    _subtract,
    _handleKeyboardNavigation,
    _handlePreviewWaterMark,
    _setElementScale,
    _setPreviewStyleStranslate,
    _getPreviewElAndDimensions,
    _handleImageCommentsPins,
    _handleImageLayers,
    _addEventListenerToOtherElements,
    _removeEventListenerFromOtherElements
  }

  this.getApi = () => api

  $scope.$watch('previewFlags.isAddingAnnotation', () => {
    if ($scope.previewFlags.isAddingAnnotation) {
      $scope.imageScale = 1
      api._updateImageScale()
    }
  })

  $scope.$watchCollection('template', () => {
    const isTemplate = !$scope.template.assetId || $scope.template.assetId !== $scope.template.id
    document.addEventListener('keydown', api._handleKeyboardNavigation)
    api._getArtPreviewSrc(isTemplate, true)
    api._handleImageCommentsPins()
  })

  $scope.$watchCollection('previewFlags', () => {
    api._handleImageCommentsPins()
  })

  const deregisterReloadPreview = $rootScope.$on('asset-preview-dialog.reload-preview-details', () => {
    const isTemplate = !$scope.template.assetId || $scope.template.assetId !== $scope.template.id
    const reloadThumb = () => {
      $rootScope.$emit(`asset-card-${$scope.template.id}.update-asset-thumbnail`)

      $timeout(() => {
        api._getArtPreviewSrc(isTemplate, true)
      })
    }

    const interval = $interval(() => {
      NewAssetService.checkAssetHasThumb($scope.template.id, 'HIGH').then((hasThumb) => {
        if (!hasThumb) {
          return
        }

        $interval.cancel(interval)
        reloadThumb()
      })
    }, 8000)

    reloadThumb()
  })

  function _handleImageCommentsPins () {
    const { tabsIsOpen, currentTab } = $scope.previewFlags
    $scope.showCommentsPins = tabsIsOpen && currentTab === 'comments'
    $scope.previewFlags.showImageZoomControls = !$scope.showCommentsPins
  }

  function _getArtPreviewSrc (isTemplate, forceRefresh = false) {
    $scope.flags.loading = true
    if (isTemplate) {
      if ($scope.publicCampaign) {
        $scope.imagePreviewURL = ShareLinkService.getThumbnailShareLink($scope.template.id, $scope.linkUuid)
      } else {
        $scope.imagePreviewURL = AssetPreviewService.getArtPreview($scope.template.id)
      }
    } else {
      const moduleLocation = AssetPreviewService.getModuleForLocation($scope.location)

      const lowResolutionImage = new Image()
      lowResolutionImage.src = AssetPreviewService.getAssetPreview($scope.template.id, moduleLocation, {
        forceRefresh,
        quality: 'HIGH'
      })
      lowResolutionImage.onload = () => {
        $scope.$apply(() => {
          $scope.imagePreviewURL = lowResolutionImage.src
          $scope.imageDimensions = {
            height: lowResolutionImage.height,
            width: lowResolutionImage.width
          }
        })

        const originalImage = new Image()
        originalImage.src = AssetPreviewService.getAssetPreview($scope.template.id, moduleLocation, {
          forceRefresh,
          quality: 'ORIGINAL'
        })
        originalImage.onload = () => {
          $scope.$apply(() => {
            const currentScale = $scope.imageScale
            $scope.imagePreviewURL = originalImage.src
            $scope.imageScale = currentScale
            api._updateImageScale()
          })
        }
      }
    }

    api._handleImageLayers()
  }

  function _handleImageLayers () {
    $scope.layersMaxHeight = `${window.innerHeight - 185}px`

    if ($scope.template?.art_layers?.length) {
      $scope.previewFlags.selectedLayerId = $scope.template.art_layers[0].id
      $scope.flags.hasMultipleLayers = $scope.template.art_layers.length > 1
      $scope.imageLayers = $scope.template.art_layers
      return
    }

    if ($scope.template?.layers?.length) {
      $scope.previewFlags.selectedLayerId = $scope.template?.layers[0]?.id
      $scope.imageLayers = $scope.template.layers
      $scope.flags.hasMultipleLayers = $scope.template.layers.length > 1
      return
    }

    $scope.previewFlags.selectedLayerId = null
    $scope.flags.hasMultipleLayers = false
    $scope.flags.loading = false
  }

  function _handlePreviewWaterMark () {
    $scope.flags.showWatermark = ($scope.template.approvalStatus !== 'APPROVED' && $scope.template.needApproval && $scope.template.isCustomizable && !$rootScope.isUserSysAdminAdminDesigner()) || !!$scope.template.unavailable

    if ($scope.contextData.section && !$rootScope.isUserSysAdminAdminDesigner()) {
      $scope.flags.showWatermark = !sectionAllowsDownload
    }

    const { watermarkEl, width, height } = api._getPreviewElAndDimensions()

    watermarkEl.style.width = width
    watermarkEl.style.height = height
  }

  function _handleKeyboardNavigation (ev) {
    const elementsToIgnore = ['uds-text-area', 'trix-editor']
    const focusedElement = ev.target.tagName.toLowerCase()

    if (elementsToIgnore.includes(focusedElement)) return

    if (ev.code === 'ArrowDown' && ev.which === 40) {
      $timeout(() => {
        $scope.nextLayer()
      }, 0, true)
    }

    if (ev.code === 'ArrowUp' && ev.which === 38) {
      $timeout(() => {
        $scope.previousLayer()
      }, 0, true)
    }
  }

  $scope.$on('$destroy', () => {
    document.removeEventListener('keydown', api._handleKeyboardNavigation)
    deregisterReloadPreview()
    api._removeEventListenerFromOtherElements()
  })

  $scope.getlayerImagePreview = (layerId) => {
    return AssetPreviewService.getArtPreview($scope.template.id, layerId)
  }

  $scope.setLayerView = (layerId, index) => {
    $scope.imagePreviewURL = AssetPreviewService.getArtPreview($scope.template.id, layerId)
    $scope.previewFlags.selectedLayerId = layerId
    $scope.currentLayerIndex = index

    SegmentService.track('arts-preview-interact', { interact_type: 'pagination', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })
  }

  $scope.previewFinishedLoading = () => {
    $scope.flags.loading = false
    api._resetImageScale()
    api._handlePreviewWaterMark()

    if ($scope.flags.isFullscreen) {
      api._handleInitialScale()
      api._updateImageScale()
    }
  }

  $scope.zoomOut = () => {
    if ($scope.imageScale > $scope.imageScaleRatio) {
      SegmentService.track('arts-preview-interact', { interact_type: 'zoom', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })

      $scope.imageScale = $scope.imageScale - $scope.imageScaleRatio
      $scope.flags.zoomOut = true
      api._updateImageScale()
    }
  }

  $scope.zoomIn = () => {
    if ($scope.imageScale < $scope.maxImageScale) {
      SegmentService.track('arts-preview-interact', { interact_type: 'zoom', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })

      $scope.imageScale = $scope.imageScale + $scope.imageScaleRatio
      api._updateImageScale()
    }
  }

  $scope.getArtVideoPreview = () => {
    const options = { fileFormat: 'mp4', videoPreview: true }

    const playButton = document.querySelector('.template-video-play')
    playButton.style.display = 'none'
    $scope.isRenderingPreview = true

    ArtsService.renderArt($scope.template.id, options).then(() => {
      if (!SocketService.isConnected('RenderVideo')) {
        SocketService.connectSocket('RenderVideo')
      }

      playButton.style.pointerEvents = 'all'

      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DOWNLOAD, [$scope.template.id])
      url = Utils.fnAddQueryToUrl(url, { fileFormat: 'mp4', originalExtension: 'mp4', videoPreview: true })

      $scope.template.videoPreview = {
        url
      }

      $scope.isRenderingPreview = false

      AssetPreviewService.closePreview()
      const isApprovalsPage = $location.path() === '/arts/company/approvals'

      if (isApprovalsPage) {
        $rootScope.$emit('arts.reopenVideoPreviewApproval', $scope.template)
        return
      }

      AssetPreviewService.openAssetPreview({
        asset: $scope.template
      })
    })
  }

  function _updateImageScale () {
    const { watermarkEl, imageEl, width, height } = api._getPreviewElAndDimensions()

    api._setElementScale(imageEl, width, height)
    api._setElementScale(watermarkEl, width, height)

    api._handleImagePanning(api._checkVerticalOverflow(imageEl), api._checkHorizontalOverflow(imageEl))
  }

  function _setElementScale (element, width, height) {
    element.style.width = width
    element.style.height = height
    element.style.transform = 'scale(' + $scope.imageScale + ', ' + $scope.imageScale + ')'
  }

  function _getPreviewElAndDimensions () {
    const watermarkEl = document.querySelector('[data-preview="watermark"]')
    const imageEl = document.querySelector('[data-preview="image"]')

    return {
      watermarkEl,
      imageEl,
      width: imageEl.naturalWidth + 'px',
      height: imageEl.naturalHeight + 'px'
    }
  }

  function _resetImageScale () {
    $scope.imageScale = 1
    const { watermarkEl, imageEl, width, height } = api._getPreviewElAndDimensions()

    api._setElementScale(imageEl, '', '')
    api._setElementScale(watermarkEl, width, height)

    if ($scope.panConfig.offset.x !== 0 || $scope.panConfig.offset.y !== 0) {
      $scope.panConfig.offset.x = 0
      $scope.panConfig.offset.y = 0
      api._setPreviewStyleStranslate($scope.panConfig.offset.x, $scope.panConfig.offset.y)
    }
  }

  function _setPreviewStyleStranslate (x, y) {
    const translateCoordinates = `${x}px ${y}px`
    $scope.panConfig.elCanvas.style.translate = translateCoordinates

    if ($scope.panConfig.elWatermark) {
      $scope.panConfig.elWatermark.style.translate = translateCoordinates
    }
  }

  function _checkVerticalOverflow (elem) {
    const elemHeight = elem.getBoundingClientRect().height
    const parentWHeight = elem.parentElement.getBoundingClientRect().height

    return elemHeight > parentWHeight
  }

  function _checkHorizontalOverflow (elem) {
    const elemWidth = elem.getBoundingClientRect().width
    const parentWidth = elem.parentElement.getBoundingClientRect().width

    return elemWidth > parentWidth
  }

  function _getImagePanningConfigs (isVertical, isHorizontal) {
    $scope.panConfig.elViewport = document.querySelector('[data-preview="wrapper"]')
    $scope.panConfig.elCanvas = document.querySelector('[data-preview="image"]')
    $scope.panConfig.elWatermark = document.querySelector('[data-preview="watermark"]')
    $scope.panConfig.isPan = false
    $scope.panConfig.isHorizontal = isHorizontal
    $scope.panConfig.isVertical = isVertical
    $scope.panConfig.imgSizeDiffX = $scope.panConfig.elCanvas.width * $scope.imageScaleRatio
    $scope.panConfig.imgSizeDiffY = $scope.panConfig.elCanvas.height * $scope.imageScaleRatio
  }

  function _handleImagePanning (isVertical, isHorizontal) {
    api._getImagePanningConfigs(isVertical, isHorizontal)
    api._handlePanningScale()

    if (isVertical || isHorizontal) {
      $scope.panConfig.elViewport.addEventListener('pointerdown', api._panStart)
      $scope.panConfig.elViewport.addEventListener('pointermove', api._panMove)
      $scope.panConfig.elViewport.addEventListener('pointerup', api._panEnd)
      api._addEventListenerToOtherElements()
    } else {
      $scope.panConfig.offset.x = 0
      $scope.panConfig.offset.y = 0
      $scope.panConfig.elViewport.removeEventListener('pointerdown', api._panStart)
      $scope.panConfig.elViewport.removeEventListener('pointermove', api._panMove)
      $scope.panConfig.elViewport.removeEventListener('pointerup', api._panEnd)
      api._removeEventListenerFromOtherElements()
    }
  };

  function _handlePanningScale () {
    if ($scope.flags.zoomOut) {
      if (!$scope.panConfig.isHorizontal) {
        $scope.panConfig.offset.x = 0
      }

      if (!$scope.panConfig.isVertical) {
        $scope.panConfig.offset.y = 0
      }

      if ($scope.panConfig.offset.x !== 0) {
        $scope.panConfig.offset.x = api._subtract($scope.panConfig.offset.x, $scope.panConfig.imgSizeDiffX / 2)
      }

      if ($scope.panConfig.offset.y !== 0) {
        $scope.panConfig.offset.y = api._subtract($scope.panConfig.offset.y, $scope.panConfig.imgSizeDiffY / 2)
      }

      api._setPreviewStyleStranslate($scope.panConfig.offset.x, $scope.panConfig.offset.y)
      $scope.flags.zoomOut = false
    }
  }

  function _subtract (minuend = 0, subtrahend = 0) {
    const isNegative = Math.sign(minuend) === -1

    if (isNegative) {
      return minuend + subtrahend
    }

    return minuend - subtrahend
  }

  function _panStart (ev) {
    ev.preventDefault()
    $scope.panConfig.isPan = true
  };

  function _panMove (ev) {
    if (!$scope.panConfig.isPan) return

    if ($scope.panConfig.isVertical) {
      const { elViewport, elCanvas } = $scope.panConfig
      const maxHeightOffset = (elCanvas.height * $scope.imageScale - elViewport.offsetHeight) / 2
      const absY = Math.abs($scope.panConfig.offset.y + ev.movementY)

      if (absY <= maxHeightOffset) {
        $scope.panConfig.offset.y += ev.movementY
      }
    }

    if ($scope.panConfig.isHorizontal) {
      const { elViewport, elCanvas } = $scope.panConfig
      const maxWidthOffset = (elCanvas.width * $scope.imageScale - elViewport.offsetWidth) / 2
      const absX = Math.abs($scope.panConfig.offset.x + ev.movementX)

      if (absX <= maxWidthOffset) {
        $scope.panConfig.offset.x += ev.movementX
      }
    }

    api._setPreviewStyleStranslate($scope.panConfig.offset.x, $scope.panConfig.offset.y)
  };

  function _panEnd () {
    $scope.panConfig.isPan = false
  };

  $scope.previousLayer = () => {
    if ($scope.currentLayerIndex !== 0) {
      $scope.currentLayerIndex = $scope.currentLayerIndex - 1
      $scope.previewFlags.selectedLayerId = $scope.imageLayers[$scope.currentLayerIndex].id
      $scope.imagePreviewURL = AssetPreviewService.getArtPreview($scope.template.id, $scope.previewFlags.selectedLayerId)

      SegmentService.track('arts-preview-interact', { interact_type: 'pagination', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })
    }
  }

  $scope.nextLayer = () => {
    if ($scope.currentLayerIndex !== $scope.imageLayers.length - 1) {
      $scope.currentLayerIndex = $scope.currentLayerIndex + 1
      $scope.previewFlags.selectedLayerId = $scope.imageLayers[$scope.currentLayerIndex].id
      $scope.imagePreviewURL = AssetPreviewService.getArtPreview($scope.template.id, $scope.previewFlags.selectedLayerId)

      SegmentService.track('arts-preview-interact', { interact_type: 'pagination', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })
    }
  }

  $scope.getImageScalePercentage = (imageScale = 0) => {
    const percentage = Math.round(imageScale * 100)

    return `${percentage}%`
  }

  $scope.getPreviewPagination = (currentLayerIndex = 0, totalPreviewLength = 0) => {
    const parsedCurrentLayerIndex = currentLayerIndex + 1

    return `${parsedCurrentLayerIndex} / ${totalPreviewLength}`
  }

  $scope.toggleFullscreen = () => {
    $scope.flags.isFullscreen = !$scope.flags.isFullscreen

    $timeout(() => {
      if (!$scope.flags.isFullscreen) {
        api._resetImageScale()
        return
      }

      SegmentService.track('arts-preview-interact', { interact_type: 'expand', type: $scope.template.isCustomizable ? 'customizable' : 'upload' })
      api._handleInitialScale()
      api._updateImageScale()
    }, 50)
  }

  function _handleInitialScale () {
    api._getImagePanningConfigs(false, false)
    const { elViewport, elCanvas } = $scope.panConfig
    const heightScale = elViewport.offsetHeight / elCanvas.height
    const widthScale = elViewport.offsetWidth / elCanvas.width
    $scope.imageScale = heightScale > widthScale ? widthScale : heightScale

    if ($scope.panConfig.offset.x !== 0 || $scope.panConfig.offset.y !== 0) {
      $scope.panConfig.offset.x = 0
      $scope.panConfig.offset.y = 0
      api._setPreviewStyleStranslate($scope.panConfig.offset.x, $scope.panConfig.offset.y)
    }
  }

  $scope.annotationMouseEnter = (pin) => {
    $scope.previewFlags.hoverCommentId = pin.approvalCommentId || pin.assetCommentId
  }

  $scope.annotationMouseLeave = () => {
    $scope.previewFlags.hoverCommentId = null
  }

  $scope.handlePinShow = (pin) => {
    const { currentAssetVersion } = $scope.previewFlags

    if ($scope.showCommentsPins && pin.timestampMs === null) {
      if (currentAssetVersion) return pin.assetComment.assetVersion === currentAssetVersion

      return true
    }

    return false
  }

  function _addEventListenerToOtherElements () {
    const elements = document.querySelectorAll('.asset-preview-header__wrapper, .asset-preview-tabs__icons--wrapper, .asset-preview-dialog__footer, .asset-image-preview__image-controls')
    elements.forEach(element => {
      element.addEventListener('pointerup', api._panEnd)
    })
  }

  function _removeEventListenerFromOtherElements () {
    const elements = document.querySelectorAll('.asset-preview-header__wrapper, .asset-preview-tabs__icons--wrapper, .asset-preview-dialog__footer, .asset-image-preview__image-controls')
    elements.forEach(element => {
      element.removeEventListener('pointerup', api._panEnd)
    })
  }

  $scope.navigateToTemplate = (direction) => {
    const actualTemplateIndex = $scope.allTemplates.findIndex(template => template.id === $scope.template.id)
    const totalTemplates = $scope.allTemplates.length
    let newIndex

    if (direction === 'previous') {
      newIndex = actualTemplateIndex === 0 ? totalTemplates - 1 : actualTemplateIndex - 1
    } else {
      newIndex = actualTemplateIndex === totalTemplates - 1 ? 0 : actualTemplateIndex + 1
    }

    $scope.template = $scope.allTemplates[newIndex]
  }
}

export { AssetPreviewImageController }
